var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 461.9 461.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n\t\tEduCode Academy\r\n\t") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    d: "M380.47,165.66A167,167,0,0,0,251.11,65.44a24.14,24.14,0,0,0-3.6-.27,24.39,24.39,0,0,0-24.36,24.36v39.6a20.61,20.61,0,0,0,41.22,0V112.6a1.43,1.43,0,0,1,1.4-1.42,1.33,1.33,0,0,1,.43.07,125.83,125.83,0,0,1-24.72,244.37,20.61,20.61,0,0,0,2.31,41.1,20.08,20.08,0,0,0,2.44-.14A167.11,167.11,0,0,0,380.47,165.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    d: "M444,141.6A231.05,231.05,0,0,0,18.4,140.49,231,231,0,0,0,443.5,321.41,231.51,231.51,0,0,0,444,141.6Zm-27.87,89.83a184.61,184.61,0,1,1-14.36-72.1A183.94,183.94,0,0,1,416.09,231.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    d: "M323.1,191.92a102.33,102.33,0,0,0-94.32-62.52h0a102.39,102.39,0,0,0-20.23,202.76,17,17,0,0,0,20.23-16.72V315a17,17,0,0,0-13.71-16.6,68,68,0,0,1,13.71-134.68h0a68.07,68.07,0,0,1,66.65,54.32A17,17,0,0,0,312,231.78h.41a17,17,0,0,0,16.72-20.23A101.24,101.24,0,0,0,323.1,191.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    d: "M226.6,252.83A22.14,22.14,0,0,1,232,208.9a22.89,22.89,0,0,1,4.74.95,1.91,1.91,0,0,1,.51,3.36l-3.58,2.61a12.92,12.92,0,0,0-2.81,18.05h0a12.91,12.91,0,0,0,18,2.86l14.75-10.65a17.75,17.75,0,0,0,3.28-25.71,48,48,0,0,0-42.44-17.06,46.68,46.68,0,0,0-37.55,26.63c-14.22,30.6,5.15,63.57,35.77,68.35a47.6,47.6,0,0,0,19.08-.89,12.62,12.62,0,0,0,7-19.68l-.32-.44a12.8,12.8,0,0,0-13.35-4.78A22.09,22.09,0,0,1,226.6,252.83Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.0f1ac477c35f17346ff4a1f6d4554139.svg";
export { ForwardRef as ReactComponent };